import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const cleanupLegacyFirebaseArtifacts = () => {
  if (typeof window === 'undefined') return;

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations?.()
      .then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      })
      .catch(() => {});
  }

  if (window.indexedDB?.deleteDatabase) {
    [
      'firebase-installations-database',
      'firebase-messaging-database',
    ].forEach((name) => {
      try {
        window.indexedDB.deleteDatabase(name);
      } catch (_) {}
    });
  }

  if (window.caches?.keys) {
    window.caches.keys()
      .then((keys) => {
        keys
          .filter((key) => /firebase|messaging|workbox|service-worker/i.test(key))
          .forEach((key) => window.caches.delete(key));
      })
      .catch(() => {});
  }
};

cleanupLegacyFirebaseArtifacts();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
